import { graphql } from '__generated__';

import { useQueryStable } from '../useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetModelExecutionRunInfo = graphql(/* GraphQL */ `
  query ModelExecutionRunInfo(
    $environmentId: BigInt!
    $start: Date!
    $end: Date!
    $uniqueId: String!
  ) {
    performance(environmentId: $environmentId) {
      modelExecutionHistory(startDate: $start, endDate: $end, uniqueId: $uniqueId) {
        date
        executionsByJob {
          jobId
          executions {
            runId
            status
            executionStartedAt
            runStartedAt
            executionTime
            isFullRefresh
          }
        }
      }
    }
  }
`);

type ModelExecutionRunInfoParams = {
  environmentId?: number;
  startDate: string;
  endDate: string;
  uniqueId: string;
  pause?: boolean;
};

export const useModelExecutionRunInfo = ({
  environmentId = 0,
  startDate,
  endDate,
  uniqueId,
  pause,
}: ModelExecutionRunInfoParams) => {
  const query = useQueryStable({
    query: GetModelExecutionRunInfo,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      uniqueId,
    },
    pause: pause || !environmentId || !startDate || !endDate || !uniqueId,
  });

  return query;
};
